// We're adding a selectedAssignmentId query param of 'null' to
// assignment creation links. As such, we should show the empty
// assignment embed by default when selectedAssignmentId is 'null'.
export const getShouldShowEmptyEditor = (selectedAssignmentId) => {
  return selectedAssignmentId === "null";
};

// As described above, urls can have a selectedAssignmentId of 'null'.
// Because params are strings, this will be truthy. As such, we need to confirm
// selectedAssignmentId isn't 'null' to determine if we're viewing a saved assignment.
export const getIsSavedAssignment = (selectedAssignmentId) => {
  const selectedAssignmentIdIsNull =
    getShouldShowEmptyEditor(selectedAssignmentId);

  return !!selectedAssignmentId && !selectedAssignmentIdIsNull;
};
